export const subscribeTran: any = {
    eu: {
        btnText: 'Subscribe',
        placeholder: 'Enter your email',
        successTips: 'Subscribed Successfully!',
        tipsCheck: "Please accept EcoFlow's Terms of Service and Privacy Policy.",
        termsHtml:
            'By subscribing, I agree to EcoFlow\'s <a href="https://account.ecoflow.com/agreement/en-us/TermsOfUse.html" target="_blank" rel="noopener noreferrer">Terms of Service</a> and <a href="https://account.ecoflow.com/agreement/en-us/PrivacyPolicy.html" target="_blank" rel="noopener noreferrer">Privacy Policy</a>.',
    },
    uk: {
        btnText: 'Subscribe',
        placeholder: 'Enter your email',
        successTips: 'Subscribed Successfully!',
        tipsCheck: "Please accept EcoFlow's Terms of Service and Privacy Policy.",
        termsHtml:
            'By subscribing, I agree to EcoFlow\'s <a href="https://account.ecoflow.com/agreement/en-us/TermsOfUse.html" target="_blank" rel="noopener noreferrer">Terms of Service</a> and <a href="https://account.ecoflow.com/agreement/en-us/PrivacyPolicy.html" target="_blank" rel="noopener noreferrer">Privacy Policy</a>.',
    },
    de: {
        btnText: 'Abonnieren',
        placeholder: 'Geben Sie ihre E-Mail Adresse ein',
        successTips: 'Erfolgreich abonniert!',
        tipsCheck: 'Bitte stimmen Sie den Datenschutzbestimmungen und Nutzungsbedingungen von EcoFlow.',
        termsHtml:
            'Durch das Abonnement erkläre ich akzeptiere die <a href="https://account.ecoflow.com/agreement/de-de/PrivacyPolicy.html" target="_blank" rel="noopener noreferrer"> Datenschutzrichtlinie</a> und <a href="https://account.ecoflow.com/agreement/de-de/TermsOfUse.html" target="_blank" rel="noopener noreferrer">Nutzungsbedingungen</a> von EcoFlow.',
    },
    fr: {
        btnText: "S'abonner",
        placeholder: 'Saisissez votre adresse e-mail',
        successTips: 'Abonnement réussi !',
        tipsCheck: "Veuillez accepter les Conditions d'utilisation et la Politique de confidentialité d'EcoFlow.",
        termsHtml:
            'En m’abonnant, j\'accepte les <a href="https://account.ecoflow.com/agreement/fr-fr/TermsOfUse.html" target="_blank" rel="noopener noreferrer">Conditions d\'utilisation</a> et la <a href="https://account.ecoflow.com/agreement/fr-fr/PrivacyPolicy.html" target="_blank" rel="noopener noreferrer">Politique de confidentialité</a>d\'EcoFlow.',
    },
    it: {
        btnText: 'Iscriviti',
        placeholder: 'Inserisci il tuo indirizzo e-mail',
        successTips: 'Iscrizione effettuata con successo! ',
        tipsCheck: 'Accetta i Termini di servizio e l’Informativa sulla privacy di EcoFlow.',
        termsHtml:
            'Accetto i <a href="https://account.ecoflow.com/agreement/it-it/TermsOfUse.html" target="_blank" rel="noopener noreferrer">Termini di servizio</a> e <a href="https://account.ecoflow.com/agreement/it-it/PrivacyPolicy.html" target="_blank" rel="noopener noreferrer">l’Informativa sulla privacy</a> di EcoFlow.',
    },
    es: {
        btnText: 'Suscribirse',
        placeholder: 'Escribe tu correo electrónico',
        successTips: '¡Te has suscrito correctamente!',
        tipsCheck: 'Acepta los Términos de servicio y la Política de privacidad de EcoFlow.',
        termsHtml:
            'Al suscribirme, acepto los <a href="https://account.ecoflow.com/agreement/es-es/TermsOfUse.html" target="_blank" rel="noopener noreferrer">Términos de servicio</a>  y la  <a href="https://account.ecoflow.com/agreement/es-es/PrivacyPolicy.html" target="_blank" rel="noopener noreferrer">Política de privacidad</a> de EcoFlow.',
    },
};
